import { NgModule } from '@angular/core';
import { AllKeysPipe } from './all-keys.pipe';

@NgModule({
    declarations: [AllKeysPipe],
    exports: [AllKeysPipe],
})
export class AllKeysPipeModule { }